import React from 'react'
import TestimonialList from '../testimonial_components/testimonial_list'

export default function TestimonialListPage() {
  return (
    <div className="content-wrapper" style={{ marginLeft: 0 }}>
      <TestimonialList />
    </div>
  )
}
